// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  userId: __t.u64().primaryKey().name("user_id"),
  vipTierId: __t.u32().name("vip_tier_id"),
  stripeSubscriptionId: __t.string().name("stripe_subscription_id"),
  stripeCustomerId: __t.string().name("stripe_customer_id"),
  status: __t.string(),
  currentPeriodStart: __t.u64().name("current_period_start"),
  currentPeriodEnd: __t.u64().name("current_period_end"),
  coinBonusGrantedAt: __t.u64().name("coin_bonus_granted_at"),
  createdAt: __t.u64().name("created_at"),
  updatedAt: __t.u64().name("updated_at"),
});
